import { Link } from "react-router-dom";
import { EnvelopeSimple, Phone, MapPin, LinkedinLogo } from "@phosphor-icons/react";
import { NAV_LINKS, CONTACT_INFO, SERVICES_SHORT, LOGO_URL } from "@/data/siteData";

export const Footer = () => (
  <footer className="bg-navy text-cream/70">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <div>
        <Link to="/" className="flex items-center gap-3.5 mb-4">
          <img src={LOGO_URL} alt="Mithra Jobs logo" className="h-11 w-11" />
          <span className="font-heading text-2xl font-semibold text-cream">Mithra Jobs</span>
        </Link>
        <p className="text-sm leading-relaxed max-w-xs">
          Mithra Jobs is a specialist teacher recruitment company helping schools connect with suitable teaching
          professionals.
        </p>
        <p className="mt-4 text-xs uppercase tracking-[0.2em] text-accent">Established 2011</p>
      </div>

      <div>
        <h4 className="text-cream font-heading text-sm uppercase tracking-[0.15em] mb-5">Navigation</h4>
        <ul className="space-y-3 text-sm">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="hover:text-accent transition-colors duration-300"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-cream font-heading text-sm uppercase tracking-[0.15em] mb-5">Services</h4>
        <ul className="space-y-3 text-sm">
          {SERVICES_SHORT.map((s) => (
            <li key={s.title}>
              <Link to="/services" className="hover:text-accent transition-colors duration-300">
                {s.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-cream font-heading text-sm uppercase tracking-[0.15em] mb-5">Contact</h4>
        <ul className="space-y-4 text-sm">
          <li className="flex gap-3">
            <MapPin size={18} className="text-accent flex-shrink-0 mt-0.5" />
            <span>{CONTACT_INFO.address}</span>
          </li>
          <li className="flex gap-3">
            <Phone size={18} className="text-accent flex-shrink-0" />
            <a
              href={`tel:${CONTACT_INFO.phone.replace(/\s+/g, "")}`}
              className="hover:text-accent"
              data-testid="footer-phone-link"
            >
              {CONTACT_INFO.phone}
            </a>
          </li>
          <li className="flex gap-3">
            <EnvelopeSimple size={18} className="text-accent flex-shrink-0" />
            <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-accent" data-testid="footer-email-link">
              {CONTACT_INFO.email}
            </a>
          </li>
        </ul>
        <a
          href={CONTACT_INFO.linkedin}
          data-testid="footer-linkedin-link"
          aria-label="LinkedIn"
          className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-cream/20 mt-5 hover:bg-accent hover:border-accent transition-colors duration-300"
        >
          <LinkedinLogo size={16} />
        </a>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 px-6 lg:px-10 text-xs text-cream/50 flex flex-col sm:flex-row justify-between gap-2 max-w-7xl mx-auto">
      <span>© {new Date().getFullYear()} Mithra Jobs. All rights reserved.</span>
      <span>Specialist Teacher Recruitment for Schools</span>
    </div>
  </footer>
);
